import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { QuickLinkTrayForm } from './QuickLinkTrayForm/QuickLinkTrayForm';
import { QuickLinkTrayModelType } from 'src/api/config/quick_link_tray/getQuickLinkTray';
import { QuickLinkTrayListItem } from './QuickLinkTrayList/QuickLinkTrayListItem';
import { ListContainer, ErrorMessageTop } from 'src/domains/layouts/shared/cms/list/List.style';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const QuickLinkTray = observer(() => {
    const { cmsState } = useAppStateContext();
    const { quickLinkTraySorted, isLoading, errorMessageForList } = cmsState.quickLinkTrayState;
    return (
        <MainContent>
            {errorMessageForList !== null ? <ErrorMessageTop>{errorMessageForList}</ErrorMessageTop> : null}

            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading} data-test='quick-link-list'>
                        <Loader isActive={isLoading} />
                        {quickLinkTraySorted.map((quickLinkTrayItem: QuickLinkTrayModelType) => {
                            return (
                                <QuickLinkTrayListItem
                                    key={quickLinkTrayItem.id}
                                    quickLinkTrayItem={quickLinkTrayItem}
                                />
                            );
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <QuickLinkTrayForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
